import useOpportunityModel from "@verivest/shared-components/src/api/hooks/models/useOpportunityModel";
import { VeriAsyncRouteComponentType } from "@verivest/shared-components/src/defines/after-js-types";
import useGetDataOrDefaults from "@verivest/shared-components/src/hooks/data/useGetDataOrDefaults";
import React from "react";
import { InvestorPortalWhiteLabelPageContainer } from "../../../components/investor-portal/layouts/InvestorPortalWhiteLabelPageContainer";
import { ManagerWhiteLabelRouteParams } from "../../../routes/investorPortalPages.types";
import {
  ManagerWhiteLabelRoutesServerInitialProps,
  WhiteLabelPageExtraProps,
} from "./types";

import { OpportunityView } from "../../../components/investor-portal/white-label/opportunities/OpportunityView";
import useMetrics from "../../../hooks/useMetrics";

export const OpportunityPage: VeriAsyncRouteComponentType<
  ManagerWhiteLabelRoutesServerInitialProps & WhiteLabelPageExtraProps,
  ManagerWhiteLabelRouteParams
> = (props) => {
  const opportunityModel = useOpportunityModel({ usePlacement: false });
  const sendMetric = useMetrics();

  const opportunityIdOrSlug = props.match.params.subSection;

  const { data: opportunity } = useGetDataOrDefaults(undefined, async () =>
    opportunityIdOrSlug
      ? (await opportunityModel.getOne(opportunityIdOrSlug))?.data
      : undefined,
  );

  React.useEffect(() => {
    if (!opportunity?.id || !props.manager?.id) return;

    sendMetric({
      event_type: "view",
      object_id: parseInt(String(opportunity.id)),
      object_type: "opportunities",
      indirect_type: "managers",
      indirect_id: parseInt(String(props.manager.id)),
      is_marketplace: false,
    });
  }, [opportunity]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!opportunity || !props.manager) {
    return <></>;
  }

  return (
    <InvestorPortalWhiteLabelPageContainer p={0}>
      <OpportunityView opportunity={opportunity} manager={props.manager} />
    </InvestorPortalWhiteLabelPageContainer>
  );
};

OpportunityPage.getInitialProps = async () => {
  const result: ManagerWhiteLabelRoutesServerInitialProps = {};
  return result;
};

OpportunityPage.getChunkName = () =>
  "investor-portal-3-manager-white-label-opportunities-page";
